export const formController = {
  // Find parent hidden inputs and return them if found.
  getParentHiddenInputs: function (el) {
    let inputAttr = {};

    while (el.parentNode) {
      el = el.parentNode;
      const inputTags = el.querySelectorAll('input[data-mz-form-field-name]');

      if (inputTags.length > 0) {
        inputTags.forEach(input => {
          const name = input.getAttribute('data-mz-form-field-name');
          inputAttr = {
            ...inputAttr,
            [name] : input.value
          }
        });

        return inputAttr
      }
    }

    return inputAttr;
  },
}
